// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"DocumentSignature_sidebar__1j4ze","boxshadowclass":"DocumentSignature_boxshadowclass__3wfEB","mySubmit":"DocumentSignature_mySubmit__1nESI"};